// components/Common/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoute = ({ requiredPermission }) => {
  const apiKey = localStorage.getItem('apiKey');
  const loginTime = localStorage.getItem('loginTime');
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const location = useLocation();

  // 1. Not logged in
  if (!apiKey) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // 2. Session expired (older than 1 hour)
  if (loginTime && (Date.now() - parseInt(loginTime)) > 3600000) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }
  // 3. Permission check (if required)
  if (requiredPermission && !permissions.includes(requiredPermission)) {
    return <Navigate to="/unauthorized" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default PrivateRoute;